(function waitForRechargeDefined() {
    if (window.rechargeInit) {
      class RechargeHelper {
        constructor() {
          this.session = null
          this.recharge = null
        }
  
        async initRechargeHelper() {
          this.recharge = await window.rechargeReady;
        }
  
        async authorize() {
          let sessionCookie = null;
          
          if (Utility && typeof Utility.getCookie === 'function') {
            sessionCookie = Utility.getCookie('recharge_session');
          }
          if (sessionCookie || sessionCookie !== '') {
            // If cookie exists, store session from cookie
            this.session = sessionCookie;
          } else {
            // If cookie does not exist, get session from recharge.auth and set cookie
            try{
            this.session = await this.recharge.auth.loginShopifyAppProxy();
            if (Utility && typeof Utility.setCookie === 'function') {
              // Set cookie for 1 hour 
              Utility.setCookie('recharge_session', JSON.stringify(this.session), 30);
            }
            console.log('session', this.session);
          } catch (error) {
            console.log('Sessionerror', error);
          }
          }
        }
        
        async checkSession() {
          let sessionCookie = null;
          if (Utility && typeof Utility.getCookie === 'function') {
            sessionCookie = Utility.getCookie('recharge_session');
          }
          if (sessionCookie && sessionCookie !== '') {
            // If cookie exists, store session from cookie
            
            this.session = JSON.parse(sessionCookie);
          } else {
            // If cookie does not exist, authorize
            await this.authorize();
          }
        }
  
        async fetchCustomer($includes) {
          await this.checkSession();
          if (!this.session) {
            console.warn('Session not found.');
            return;
          }
          try {
            return await this.recharge.customer.getCustomer(this.session, { include: $includes });
          } catch (error) {
            console.log(error);
          }
        }

        async fetchOrderList() {
          try {
            this.checkSession();
            return await this.recharge.order.listOrders(this.session, { limit: 25, sort_by: 'id-desc', });
          } catch (error) {
            console.log(error,"error");
            return {error: error};
            
          }
        }

        async fetchOrderListByExternalOrderId(externalOrderId) {
          try {
            this.checkSession();
            return await this.recharge.order.listOrders(this.session, { limit: 25, sort_by: 'id-desc', external_order_id: externalOrderId });
          } catch (error) {
            console.log(error);
          }
        }
  
        async fetchGraphQlProducts(subscriptions, recharge = false) {
          var subscriptionProductIdList = [];
          let productIds = recharge
            ? new Set(subscriptions.map(subscription => subscription.external_product_id))
            : new Set(subscriptions.map(subscription => subscription.external_product_id.ecommerce));
  
          productIds.forEach(productId => {
            if (recharge) {
              if (!subscriptionProductIdList.includes(productId)) {
                subscriptionProductIdList.push(productId);
              }
            } else {
              subscriptionProductIdList.push(productId);
            }
          });
  
          try {
            const graphQlJsonData = recharge ? sessionStorage.getItem('recharge-products') : sessionStorage.getItem('products') || null;
            let updatedGraphQlJsonData = {};
  
            if (graphQlJsonData === null) {
              // If recharge-products is null, fetch all products
              updatedGraphQlJsonData = await this.fetchAllProducts(subscriptionProductIdList);
            } else {
              const existingProductIds = new Set(Object.keys(JSON.parse(graphQlJsonData)));
              const newProductIds = subscriptionProductIdList.filter(id => !existingProductIds.has(id));
  
              if (newProductIds.length === 0) {
                return JSON.parse(graphQlJsonData);
              }
  
              // Construct GraphQL query for new product ids
              let query = "";
              for (const id of newProductIds) {
                let tempQuery = `
                      product_${id.toString()}: product(id: "gid://shopify/Product/${id}") {
                          id
                          handle
                          tags
                          metafield(key: "number_of_meals", namespace: "custom") {
                              value
                          }
                          images(first: 5) {
                              edges {
                                  node {
                                      src
                                  }
                              }
                          }
                          variants(first: 99) {
                              edges {
                                  node {
                                      id
                                      price{
                                          amount
                                      }
                                      image {
                                          src
                                      }
                                  }
                              }
                          }
                      }
                  `;
                query += tempQuery;
              }
  
              // Send GraphQL request
              const response = await fetch('/api/2023-07/graphql.json', {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json',
                  "Access-Control-Origin": "*",
                  'X-Shopify-Storefront-Access-Token': '7bf0752c5db6ac39ff118c9c498ace77'
                },
                body: JSON.stringify({ query: `{${query}}` }),
              });
  
              const { data } = await response.json();
              let productJson = {};
              for (const key in data) {
                if (data.hasOwnProperty(key)) {
                  let id = parseInt(key.match(/\d+/)[0]);
                  let productData = data[key];
                  if (productData !== null) {
                    let { handle, images: { edges }, variants, metafield, tags } = productData;
                    let productImages = edges.map(edge => edge.node);
                    let variantObjects = variants?.edges.map((variant) => ({
                      id: variant.node.id.replace('gid://shopify/ProductVariant/', ''),
                      image: variant.node.image,
                      price: variant.node.price
                    })) || [];
                    productJson[id] = {
                      id,
                      handle,
                      tags,
                      metafield,
                      images: productImages,
                      variants: variantObjects
                    };
                  }
                }
              }
              updatedGraphQlJsonData = { ...JSON.parse(graphQlJsonData), ...productJson };
              updatedGraphQlJsonData = Object.fromEntries(
                Object.entries(updatedGraphQlJsonData).filter(([id]) => subscriptionProductIdList.includes(id))
              );
            }
  
            recharge
              ? sessionStorage.setItem('recharge-products', JSON.stringify(updatedGraphQlJsonData))
              : sessionStorage.setItem('products', JSON.stringify(updatedGraphQlJsonData));
  
            return updatedGraphQlJsonData;
          } catch (e) {
            console.log("Error from fetch product data:", e);
          }
        }
  
        async fetchAllProducts(productIds) {
          try {
            let query = "";
            for (const id of productIds) {
              let tempQuery = `
                  product_${id.toString()}: product(id: "gid://shopify/Product/${id}") {
                      id
                      title
                      handle
                      tags
                      metafield(key: "number_of_meals", namespace: "custom") {
                          value
                      }
                      images(first: 5) {
                          edges {
                              node {
                                  src
                              }
                          }
                      }
                      variants(first: 99) {
                          edges {
                              node {
                                  id
                                  price{
                                      amount
                                  }
                                  image {
                                      src
                                  }
                              }
                          }
                      }
                  }
              `;
              query += tempQuery;
            }
  
            // Send GraphQL request
            const response = await fetch('/api/2023-07/graphql.json', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
                "Access-Control-Origin": "*",
                'X-Shopify-Storefront-Access-Token': '7bf0752c5db6ac39ff118c9c498ace77'
              },
              body: JSON.stringify({ query: `{${query}}` }),
            });
  
            const { data } = await response.json();
            let productJson = {};
            for (const key in data) {
              if (data.hasOwnProperty(key)) {
                let id = parseInt(key.match(/\d+/)[0]);
                let productData = data[key];
                if (productData !== null) {
                  let { handle, images: { edges }, variants, metafield, tags, title } = productData;
                  let productImages = edges.map(edge => edge.node);
                  let variantObjects = variants?.edges.map((variant) => ({
                    id: variant.node.id.replace('gid://shopify/ProductVariant/', ''),
                    image: variant.node.image,
                    price: variant.node.price
                  })) || [];
                  productJson[id] = {
                    id,
                    handle,
                    title,
                    tags,
                    metafield,
                    images: productImages,
                    variants: variantObjects
                  };
                }
              }
            }
            return productJson;
          } catch (error) {
            console.log("Error fetching all products:", error);
            return {};
          }
        }
  
        async fetchOneTime() {
          try {
            const { onetimes } = await this.recharge.onetime.listOnetimes(this.session, {
              limit: 25,
              sort_by: 'id-asc',
            });
            subscriptionProductIds = [...new Set(onetimes.map(item => item.external_product_id.ecommerce))];
            return onetimes
          } catch (error) {
            console.log('Error while fetching one-time subscription ====>', error)
          }
        }
  
  
        /**
         Fetch Shopify Products JSON of subscription products
         * @return  {JSON} - data. Product
         
         * For more information : https://shopify.dev/api/admin-rest/2022-07/resources/product#get-products
         * @param handle
         */
  
        async fetchStoreFrontProduct(handle) {
          try {
            const response = await fetch(`/products/${handle}.js`);
            if (!response.ok) {
              console.log(`Error fetching Storefront Product: ${handle} - ${response.statusText}`);
            }
            return await response.json();
          } catch (error) {
            console.log(`Error while fetching Storefront Product: ${handle}`, error);
          }
        }
  
        async updateSubscription(subscription_id, updateSubscriptionObj) {
          try {
            return await this.recharge.subscription.updateSubscription(this.session, subscription_id, updateSubscriptionObj)
          } catch (error) {
            console.log(`Error while updating subscription: ${subscription_id} ===>`, error);
            throw error;
          }
        }
  
        async fetchSubscription() {
          try {
            await this.checkSession()
            return await this.recharge.subscription.listSubscriptions(this.session, {
              limit: 25,
              sort_by: 'id-asc',
              include: ['bundle_product','bundle_selections','metafields','address']
            });
          } catch (error) {
            console.log(error)
          }
        }
  
        async _changeChargeDateAddon(addonsList, newChargeDate) {
          let promises = [];
          for (let addon of addonsList) {
            let addonObj = {
              'commit_update': true,
              'next_charge_scheduled_at': newChargeDate
            }
            promises.push(await this.recharge.onetime.updateOnetime(this.session, addon.id, addonObj));
          }
          try {
            await Promise.all(promises);
          } catch (error) {
            console.log('error in updating addon ===>', error)
          }
        }
  
        /**
         Change Charge Date
         
         * @return  {JSON} - subscription object
         
         * For more information : https://storefront.rechargepayments.com/client/docs/methods/api/subscription/#updatesubscription---
         * @param subscription_id
         * @param next_charge_date
         */
        async changeChargeDate(subscription_id, next_charge_date) {
          try {
            return await this.recharge.subscription.updateSubscriptionChargeDate(this.session, subscription_id, next_charge_date);
          } catch (error) {
            console.log('error in updating charge date ===>', error)
          }
        }
  
  
        async updateBundles(bundleID, bundleData) {
          try {
            const bundles = await this.recharge.bundle.updateBundleSelection(this.session, bundleID, bundleData);
            return bundles
          } catch (error) {
            console.log(error, "error");
          }
        }

        async fetchCredit() {
          try {
            return await this.recharge.credit.getCreditSummary(this.session);
          } catch (error) {
            console.log(error, "error");
          }
        }

        async applyCreditToNextOrder(recurring = true) {
          try {
            const updated_customer = await recharge.credit.setApplyCreditsToNextCharge(
              this.session,
              // Control whether credits should only be applied to recurring charges
              { recurring: recurring }
            );
            return updated_customer;
          } catch (error) {
            console.log(error, "error");
          }
        }

        async createBundles(bundle) {
          try {
            return await this.recharge.bundle.createBundleSelection(this.session, bundle);
          } catch (error) {
            console.log(error, "error");
            console.log('Error while creating Bundle',)
          }
        }
  
        async getBundleList() {
          await this.checkSession();
          try {
            return await this.recharge.bundle.listBundleSelections(this.session, {
              limit: 25,
              sort_by: 'id-asc',
            });
          } catch (error) {
            if (error.status === 401) {
              await this.authorize();
              return await this.getBundleList();
            } else {
              console.log('Error while fetching bundle list:', error);
              return null;
            }
          }
        }
  
        async updateAddress(addressID, updates) {
          await this.checkSession();
          try {
            return await this.recharge.address.updateAddress(this.session, addressID, updates);
          } catch (error) {
            if (error.status === 401) {
              await this.authorize();
              return await this.updateAddress(addressID, updates);
            } else {
              console.log('Error while updating address:', error);
              return null;
            }
          }
        }
        async createAddress(address) {
          await this.checkSession();
          try {
            return await this.recharge.address.createAddress(this.session, address);
          } catch (error) {
            if (error.status === 401) {
              await this.authorize();
              return await this.createAddress(address);
            } else {
              console.log('Error while creating address:', error);
              return error;
            }
          }
        }
         async fetchCharges() {
          await this.checkSession();
          try {
            let { charges } = await this.recharge.charge.listCharges(this.session, {
              status: [ 'queued'],
            limit: 25, 
            sort_by: 'scheduled_at-asc',
            include: ['subscriptions',]
          });

          return charges;
          } catch (error) {
            if (error.status === 401) {
              await this.authorize();
              return await this.fetchCharges();
            } else {
              console.log('Error while fetching charges:', error);
              return null;
            }
          }
        }
        async createNextOrder() {
          console.log(await this.fetchCharges(),"charges");
          let all_charges = await this.fetchCharges();
        }
  
  
        async cancelSubscription(subscriptionID, cancellationData) {
          await this.checkSession();
          try {
            return await this.recharge.subscription.cancelSubscription(this.session, subscriptionID, cancellationData);
          } catch (error) {
            if (error.status === 401) {
              await this.authorize();
              return await this.cancelSubscription(subscriptionID, cancellationData);
            } else {
              console.log('Error while cancelling subscription:', error);
              return null;
            }
          }
        }
  
        /**
         Cancel Subscriptions
         
         
         * @return  {JSON} - subscription object
         
         * For more information : https://storefront.rechargepayments.com/client/docs/methods/api/subscription/#cancelsubscription---
         * @param addressID
         * @param cancellationData
         */
        async updateBulkSubscription(addressID, cancellationData) {
          await this.checkSession();
          try {
            return await this.recharge.subscription.updateSubscriptions(this.session, addressID, cancellationData);
          } catch (error) {
            if (error.status === 401) {
              await this.authorize();
              return await this.updateBulkSubscription(addressID, cancellationData);
            } else {
              console.log('Error while updating bulk subscription:', error);
              return null;
            }
          }
        }
  
  
        async createOneTimeAddon(data) {
          await this.checkSession();
          try {
            return await this.recharge.onetime.createOnetime(this.session, data);
          } catch (error) {
            if (error.status === 401) {
              await this.authorize();
              return await this.createOneTimeAddon(data);
            } else {
              console.log('Error while creating one-time addon:', error);
              return null;
            }
          }
        }
  
        async updateOneTimeAddon(oneTimeID, updates) {
          await this.checkSession();
          try {
            return await this.recharge.onetime.updateOnetime(this.session, oneTimeID, updates);
          } catch (error) {
            if (error.status === 401) {
              await this.authorize();
              return await this.updateOneTimeAddon(oneTimeID, updates);
            } else {
              console.log('Error while updating one time addon:', error);
              return null;
            }
          }
        }
  
        async createSubscriptionProduct(data) {
          await this.checkSession();
          try {
            return await this.recharge.subscription.createSubscription(this.session, data);
          } catch (error) {
            if (error.status === 401) {
              await this.authorize();
              return await this.createSubscriptionProduct(data);
            } else {
              console.log('Error while creating subscription:', error);
              return null;
            }
          }
        }
  
        async removeOnetimeAddon(addonId) {
          await this.checkSession();
          try {
            return await this.recharge.onetime.deleteOnetime(this.session, addonId);
          } catch (error) {
            if (error.status === 401) {
              await this.authorize();
              return await this.removeOnetimeAddon(addonId);
            } else {
              console.log('Error while removing addon:', error);
              return null;
            }
          }
        }
  
        async processCharge(chargeID) {
          await this.checkSession();
          try {
            return await this.recharge.charge.processCharge(this.session, chargeID);
          } catch (error) {
            if (error.status === 401) {
              await this.authorize();
              return await this.processCharge(chargeID);
            } else {
              console.log('Error while processing order:', error);
              return null;
            }
          }
        }
  
        async fetchChargeDetails(chargeID) {
          await this.checkSession();
          try {
            return await this.recharge.charge.getCharge(this.session, chargeID, { include: ['subscriptions'] });
          } catch (error) {
            if (error.status === 401) {
              await this.authorize();
              return await this.fetchChargeDetails(chargeID);
            } else {
              console.log('Error while fetching charge details:', error);
              return null;
            }
          }
        }
  
        async changeShippingAddress(addressID, updatedAddressObject) {
          await this.checkSession();
          try {
            return await this.recharge.address.updateAddress(this.session, addressID, updatedAddressObject);
          } catch (error) {
            if (error.status === 401) {
              await this.authorize();
              return await this.changeShippingAddress(addressID, updatedAddressObject);
            } else {
              console.log('Error while updating address:', error);
              return null;
            }
          }
        }
  
        async updatePaymentMethod(paymentMethodID, addressID) {
          await this.checkSession();
          try {
            return await this.recharge.customer.sendCustomerNotification(this.session, 'SHOPIFY_UPDATE_PAYMENT_INFO', {
              address_id: addressID,
              payment_method_id: paymentMethodID,
            });
          } catch (error) {
            if (error.status === 422) {
              // Rollbar.error(`Recharge => Users are trying to enter invalid address`);
              toastr.error('Enter Valid Address', JSON.parse(error.message).province ?? JSON.parse(error.message).zip ?? JSON.parse(error.message).all ?? 'Invalid Address', 'error')
              console.log('error in updating address ===>', error);
            } else {
              // Rollbar.error(`Recharge => Error in change shipping addresss`);
              toastr.error('Something went wrong', 'Error in Updating address', 'error')
              console.log('error in updating address ===>', error);
            }
          }
        }
  
        async updatePaymentMethod(paymentMethodID, addressID) {
          await this.checkSession();
          try {
            return await this.recharge.customer.sendCustomerNotification(this.session, 'SHOPIFY_UPDATE_PAYMENT_INFO', {
              address_id: addressID,
              payment_method_id: paymentMethodID,
            });
          } catch (error) {
            if (error.status === 401) {
              await this.authorize();
              return await this.updatePaymentMethod(paymentMethodID, addressID);
            } else {
              console.log('Error while updating payment method:', error);
              return null;
            }
          }
        }
  
        async getProducts() {
          await this.checkSession();
          try {
            let { products } = await this.recharge.product.productSearch(this.session, {
              format_version: '2022-06',
            });
            return products;
          } catch (error) {
            if (error.status === 401) {
              await this.authorize();
              return await this.getProducts();
            } else {
              console.log('Error while fetching the products from recharge:', error);
              return null;
            }
          }
        }
  
        async getBundleId(bundle) {
          await this.checkSession();
          try {
            return await this.recharge.bundle.getBundleId(bundle)
          } catch (error) {
            if (error.status === 401) {
              await this.authorize();
              return await this.getBundleId(bundle);
            } else {
              console.log('Error while fetching bundleID:', error);
              return null;
            }
          }
        }
      }
  
      window.rechargeHelper = new RechargeHelper();
      window.rechargeHelper.initRechargeHelper()
  
    } else {
      // wait for recharge to be defined
      document.addEventListener('rechargeReady', waitForRechargeDefined);
    }
  })();
  
  
  class CreatePlaylist{
    constructor(bundleProductId,bundleVariantId,bundleCollectionId,bundleVarianTitle="300g",bagSize = 2,brewType = { espresso:0, filter:1 }) {
      this.bundleProductId = bundleProductId;
      this.bundleCollectionId = bundleCollectionId;
      this.bundleVariantId = bundleVariantId;
      this.products = collectionProducts[this.bundleCollectionId];
      this.espressoCount = brewType.espresso;
      this.filterCount = brewType.filter;
    }
    createBundleObject(){
      const bundle = {
        externalProductId: this.bundleProductId , // Bundle's Shopify Product ID
        externalVariantId: this.bundleVariantId , // Bundle's Shopify Variant ID
      };
      
    }
    getSeperatedProductsByTag(){
      return{
        filter: this.products.filter(product => product.tags.includes("filter")),
        espresso: this.products.filter(product => product.tags.includes("espresso")),
      }
    }
    bundleSelections(){
      this.products.forEach(product => {
        const bundleSelection = {
          collectionId: this.bundleCollectionId,
          externalProductId: product.id,
          externalVariantId: product.variants.find(variant => variant.title == this.bundleVarianTitle).id,
        }
      })
    }
  
  }
   
  
  /**
   * Returns an object mapping each tag to an array of products in the given collection
   * that include that tag. For example, { filter: [...], espresso: [...] }
   * 
   * @param {string|number} collectionId - The ID of the collection to search in.
   * @param {Array<string>} tags - Array of tags to filter products by (default: ["filter", "espresso"]).
   * @returns {Object} - An object where each key is a tag and the value is an array of matching products.
   */
  function getProductsByCollectionIdWithTags(collectionId, tags = ["filter", "espresso"]) {
    const products = collectionProducts[collectionId] || [];
    const result = {};
    tags.forEach(tag => {
      // Filter products that include the current tag
      result[tag] = products.filter(product => product.tags.includes(tag));
    });
    return result;
  }
  
  /**
   * Returns an object mapping each tag to an array of unique products from the given collection,
   * with the number of products per tag limited by tagWithCounts, optionally excluding specified products,
   * and ensuring no duplicate products are included across all tags in the result.
   *
   * @param {string|number} collectionId - The ID of the collection to search in.
   * @param {Object} tagWithCounts - An object where keys are tags and values are the number of products to select for each tag.
   * @param {Array} excludeProductIDs - Array of product IDs to exclude from the results.
   * @param {boolean} enableVariantAvailability - If true, only include products with available variants (optionally filtered by variantTitle).
   * @param {string} variantTitle - The title of the variant to check for availability (default: "300g").
   * @param {boolean} enableSellingPlanAvailability - If true, only include products with available selling plans (optionally filtered by sellingPlanName).
   * @param {string} sellingPlanName - The name of the selling plan to check for availability (default: "3 weeks").
   * @returns {Object} - An object where each key is a tag and the value is an array of selected unique products for that tag.
   */
  
  function getProductsSelections(
    collectionId,
    tagWithCounts,
    excludeProductIDs = [],
    enableVariantAvailability = false,
    variantTitle = "300g",
    enableSellingPlanAvailability = false,
    sellingPlanName = "3 weeks"
  ) {
    const tags = Object.keys(tagWithCounts);
    const productsByTag = getProductsByCollectionIdWithTags(collectionId, tags);
    const result = {};
    const excludeSet = new Set(excludeProductIDs);
    const usedProductIds = new Set();
  
    for (const tag of tags) {
      let filteredProducts = (productsByTag[tag] || []).filter(product => 
        !excludeSet.has(product.id) && !usedProductIds.has(product.id)
      );
  
      if (enableVariantAvailability) {
        filteredProducts = filteredProducts.filter(product => {
          let variant;
          if (variantTitle) {
            variant = product.variants.find(v => v.title === variantTitle);
          } else {
            variant = product.variants && product.variants.length > 0 ? product.variants[0] : null;
          }
          return variant && (variant.available || variant.available === undefined);
        });
      }
  
      if (enableSellingPlanAvailability) {
        filteredProducts = filteredProducts.filter(product => {
          // Check if product has selling plan groups
          if (!product.selling_plan_groups || product.selling_plan_groups.length === 0) {
            return false;
          }
  
          // Find selling plan group that matches the sellingPlanName
          const sellingPlanGroup = product.selling_plan_groups.find(group => 
            group.name.toLowerCase().includes(sellingPlanName.toLowerCase())
          );
  
          if (!sellingPlanGroup) {
            return false;
          }
  
          // Check if any variant has selling plan allocations for this group
          let hasSellingPlanAllocation = false;
          product.variants.forEach(variant => {
            if (variant.selling_plan_allocations) {
              const allocation = variant.selling_plan_allocations.find(allocation => 
                allocation.selling_plan_group_id === sellingPlanGroup.id
              );
              if (allocation) {
                hasSellingPlanAllocation = true;
              }
            }
          });
  
          return hasSellingPlanAllocation;
        });
      }
      
  
      // Only take as many products as specified by tagWithCounts[tag]
      const selectedProducts = filteredProducts.slice(0, tagWithCounts[tag]);
      // Mark these product IDs as used to prevent duplicates across tags
      selectedProducts.forEach(product => usedProductIds.add(product.id));
      result[tag] = selectedProducts;
    }
  
    return result;
  }
  
  function getProductSelectionBySellingPlan(
    collectionId,
    tagWithCounts,
    excludeProductIDs = [],
    enableVariantAvailability = false,
    variantTitle = "300g",
    enableSellingPlanAvailability = true,
    sellingPlanName = "3 weeks"
  ){
    const products = getProductsSelections(
      collectionId,
      tagWithCounts,
      excludeProductIDs,
      enableVariantAvailability,
      variantTitle,
      enableSellingPlanAvailability = true,
      sellingPlanName
    )
    const selectionProductObject = [];
    const productListing = [];
    const playlistData = helpers.getPlaylistDataByCollectionId(collectionId);
    let totalPrice = 0;
    Object.keys(products).forEach(tag => {
      products[tag].forEach(product => {
        const productObject = {
          externalProductId: product.id,
          externalVariantId: product.variants.find(variant => variant.title === variantTitle)?.id || product.variants[0].id,
          quantity:1,
          sellingPlan: null,
        }
        const sellingPlanGroupId = product.selling_plan_groups.find(group =>{
          return group.name.toLowerCase().includes(sellingPlanName);
        })
        if(sellingPlanGroupId){
          product.variants.forEach(variant => {
            const sellingPlanAllocation = variant.selling_plan_allocations.find(allocation => {
              return allocation.selling_plan_group_id === sellingPlanGroupId.id
            })
            if(sellingPlanAllocation){
            productObject.sellingPlan = sellingPlanAllocation.selling_plan_id;
            }
          })
          
        }
        productObject.collectionId = collectionId;
        selectionProductObject.push(productObject);
        productListing.push(product);
        totalPrice += product.variants.find(variant => variant.title === variantTitle).price;
      })
    })
    return {selectionProductObject,productListing,totalPrice ,playlistData};
  }

  function getAvailableProducts(collectionId, variantTitle = "300g") {
    const products = collectionProducts[collectionId] || [];
    const filterProducts = products.filter(product => {
      if (!Array.isArray(product.tags)) return false;
      if (!Array.isArray(product.variants)) return false;
      // Check if any variant title contains variantTitle
      const hasMatchingVariant = product.variants.some(variant => 
        typeof variant.title === 'string' && variant.title.includes(variantTitle)
      );
      if (!hasMatchingVariant) return false;
      const tagsLower = product.tags.map(tag => tag.toLowerCase());
      return tagsLower.includes('filter');
    });
    const espressoProducts = products.filter(product => {
      if (!Array.isArray(product.tags)) return false;
      if (!Array.isArray(product.variants)) return false;
      // Check if any variant title contains variantTitle
      const hasMatchingVariant = product.variants.some(variant => 
        typeof variant.title === 'string' && variant.title.includes(variantTitle)
      );
      if (!hasMatchingVariant) return false;
      const tagsLower = product.tags.map(tag => tag.toLowerCase());
      return tagsLower.includes('espresso');
    });
    return { filter: filterProducts, espresso: espressoProducts };
  }